import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function PageNavbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  const handleLinkClick = () => {
    setMobileOpen(false);
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center gap-3 group cursor-pointer">
              <img
                src="https://static.readdy.ai/image/b35b46597ae7b9f4c7fd1e38dab17f7e/77cc381fab694922123e05ab27ba61f2.png"
                alt="BR Webdesign & AI Solutions Logo"
                className="w-12 h-12 object-contain"
              />
              <div className="flex flex-col leading-tight">
                <span className="text-lg font-caprasimo text-brand-black group-hover:text-brand-green-light transition-colors whitespace-nowrap">
                  BR Webdesign
                </span>
                <span className="text-[10px] font-semibold text-brand-grey tracking-wider uppercase whitespace-nowrap">& AI Solutions</span>
              </div>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className={`text-base transition-all cursor-pointer whitespace-nowrap ${
                  isActive('/') 
                    ? 'font-semibold text-brand-black' 
                    : 'font-normal text-neutral-600 hover:text-brand-black hover:font-semibold'
                }`}
              >
                Startseite
              </Link>
              <Link
                to="/services"
                className={`text-base transition-all cursor-pointer whitespace-nowrap ${
                  isActive('/services') 
                    ? 'font-semibold text-brand-black' 
                    : 'font-normal text-neutral-600 hover:text-brand-black hover:font-semibold'
                }`}
              >
                Leistungen
              </Link>
              <Link
                to="/portfolio"
                className={`text-base transition-all cursor-pointer whitespace-nowrap ${
                  isActive('/portfolio') 
                    ? 'font-semibold text-brand-black' 
                    : 'font-normal text-neutral-600 hover:text-brand-black hover:font-semibold'
                }`}
              >
                Portfolio
              </Link>
              <Link
                to="/pricing"
                className={`text-base transition-all cursor-pointer whitespace-nowrap ${
                  isActive('/pricing') 
                    ? 'font-semibold text-brand-black' 
                    : 'font-normal text-neutral-600 hover:text-brand-black hover:font-semibold'
                }`}
              >
                Preise
              </Link>
              <Link
                to="/about"
                className={`text-base transition-all cursor-pointer whitespace-nowrap ${
                  isActive('/about') 
                    ? 'font-semibold text-brand-black' 
                    : 'font-normal text-neutral-600 hover:text-brand-black hover:font-semibold'
                }`}
              >
                Über mich
              </Link>
              <Link
                to="/contact"
                className={`text-base transition-all cursor-pointer whitespace-nowrap ${
                  isActive('/contact') 
                    ? 'font-semibold text-brand-black' 
                    : 'font-normal text-neutral-600 hover:text-brand-black hover:font-semibold'
                }`}
              >
                Kontakt
              </Link>
            </div>

            <div className="flex items-center gap-4">
              <a href="tel:01623651571" className="hidden md:flex items-center gap-2 text-sm text-brand-black hover:text-brand-green transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line"></i>
                0162 365 1571
              </a>
              <a href="/contact" className="hidden md:block px-5 py-2.5 text-sm font-medium text-white bg-brand-green hover:bg-brand-green-light rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                Jetzt anfragen
              </a>

              {/* Mobile Hamburger Button */}
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="md:hidden w-11 h-11 flex items-center justify-center text-brand-black hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                aria-label="Menü öffnen"
              >
                <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Mobile Menu */}
      <div
        className={`fixed top-20 left-0 right-0 bg-white border-b border-neutral-200 shadow-lg z-40 md:hidden transition-transform duration-300 ${
          mobileOpen ? 'translate-y-0' : '-translate-y-full'
        }`}
      >
        <div className="px-4 py-6 space-y-1">
          <Link
            to="/"
            onClick={handleLinkClick}
            className={`block px-4 py-3 text-base font-medium rounded-lg transition-colors cursor-pointer ${
              isActive('/')
                ? 'bg-brand-green/10 text-brand-green font-semibold'
                : 'text-brand-black hover:bg-gray-50 hover:text-brand-green'
            }`}
          >
            Startseite
          </Link>
          <Link
            to="/services"
            onClick={handleLinkClick}
            className={`block px-4 py-3 text-base font-medium rounded-lg transition-colors cursor-pointer ${
              isActive('/services')
                ? 'bg-brand-green/10 text-brand-green font-semibold'
                : 'text-brand-black hover:bg-gray-50 hover:text-brand-green'
            }`}
          >
            Leistungen
          </Link>
          <Link
            to="/portfolio"
            onClick={handleLinkClick}
            className={`block px-4 py-3 text-base font-medium rounded-lg transition-colors cursor-pointer ${
              isActive('/portfolio')
                ? 'bg-brand-green/10 text-brand-green font-semibold'
                : 'text-brand-black hover:bg-gray-50 hover:text-brand-green'
            }`}
          >
            Portfolio
          </Link>
          <Link
            to="/pricing"
            onClick={handleLinkClick}
            className={`block px-4 py-3 text-base font-medium rounded-lg transition-colors cursor-pointer ${
              isActive('/pricing')
                ? 'bg-brand-green/10 text-brand-green font-semibold'
                : 'text-brand-black hover:bg-gray-50 hover:text-brand-green'
            }`}
          >
            Preise
          </Link>
          <Link
            to="/about"
            onClick={handleLinkClick}
            className={`block px-4 py-3 text-base font-medium rounded-lg transition-colors cursor-pointer ${
              isActive('/about')
                ? 'bg-brand-green/10 text-brand-green font-semibold'
                : 'text-brand-black hover:bg-gray-50 hover:text-brand-green'
            }`}
          >
            Über mich
          </Link>
          <Link
            to="/contact"
            onClick={handleLinkClick}
            className={`block px-4 py-3 text-base font-medium rounded-lg transition-colors cursor-pointer ${
              isActive('/contact')
                ? 'bg-brand-green/10 text-brand-green font-semibold'
                : 'text-brand-black hover:bg-gray-50 hover:text-brand-green'
            }`}
          >
            Kontakt
          </Link>

          <div className="pt-4 border-t border-neutral-200 mt-4">
            <a
              href="tel:01623651571"
              className="flex items-center justify-center gap-2 px-4 py-3 text-base font-medium text-brand-black hover:bg-gray-50 rounded-lg transition-colors cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              0162 365 1571
            </a>
            <a
              href="/contact"
              onClick={handleLinkClick}
              className="block w-full mt-2 bg-brand-green hover:bg-brand-green-light text-white text-center px-6 py-3 rounded-lg text-base font-semibold transition-all cursor-pointer"
            >
              Jetzt anfragen
            </a>
          </div>
        </div>
      </div>
    </>
  );
}